// extracted by mini-css-extract-plugin
module.exports = {"categoryIcon":"categories-panel-category_categoryIcon__15mu2"};